import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { parseRmaOrderDTOList, RmaOrderDTO } from 'components/ordering/rma/api/dtos/rma-order-dto.js'
import { parseRmaProductDTOList, RmaProductDTO } from 'components/ordering/rma/api/dtos/rma-product-dto.js'

type SearchRmaOrdersPayload = {
  searchTerm: string
  type?: string
  shipmentID?: string
  saleID?: string
  limit?: number
}

const isDefined = (value: unknown): value is string | number =>
  value !== undefined && value !== null

export class SearchRmaOrders extends RmaRequest<RmaOrderDTO[] | RmaProductDTO[], never> {
  path: string
  private readonly type: string | undefined

  constructor({ searchTerm, type, shipmentID, saleID, limit }: SearchRmaOrdersPayload) {
    super()
    this.type = type
    const params = new URLSearchParams(
      Object.entries({ searchTerm, type, shipmentID, saleID, limit: limit?.toString() })
        .filter(([, v]) => isDefined(v)) as [string, string][]
    )
    this.path = `account/rma/search/order/?${params}`
  }

  // type=products returns product rows, not orders — parse them accordingly.
  override parseResponse = (data: unknown) => {
    const results = (data as { results: unknown }).results
    return this.type === 'products'
      ? parseRmaProductDTOList(results)
      : parseRmaOrderDTOList(results)
  }
}
